import React, { useContext } from "react";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { getTasks } from "../../../MyApi/crm/tasks";
import LoadingSpinner from "../../UI/spinner";
import CustomizerContext from "../../../_helper/Customizer";
import SingleTasks from "../singleTasks";



const TasksCard = () => {
  const { data, isLoading ,error} = useQuery("getTasks", getTasks);
  const {t}= useTranslation()
  const {mix_background_layout}=useContext(CustomizerContext)


  if (isLoading) {
    return <LoadingSpinner />;
   }

   if (!data) {
    return <div> no data available</div>;
  } 
  if(error){
    toast.error("error in get Tasks")
  }

const TasksData = data?.data || [];


  return (
    <div class="col-md-8">
              <div class="card">
      <div class="card-header">
        <h5>المهام</h5>
      </div>
      <div class="row">
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead>
              <th>المهمة</th>
              <th>الحالة</th>
              <th>الانجاز</th>
            </thead>
            <tbody>
          {TasksData.map((task) => (
          <SingleTasks key={task.id} task={task} t={t}/>
        ))}
        </tbody>
          </table>
        </div>
        </div>
        
      </div>
    </div>
    
       
   
  );
};

export default TasksCard;
